<div
  class="stat"
  [attr.data-color]="color"
>
  @if (datum) {
    <div
      class="middle-content"
      [innerHTML]="datum"
    ></div>
  } @else {
    <div
      class="middle-content"
    >
      <motn-spinner></motn-spinner>
    </div>
  }

  <div
    class="bottom-content"
  >
    @if (icon) {
      <i
        [ngClass]="['fa-regular', 'fa-' + icon]"
      ></i>
    }
    {{title}}
  </div>
</div>
